import axios from "axios";
import { cloudCableSelectionProductIds } from "../../../../../settings";

export default {
  submitMMYData: async ({ commit, state, rootState }, cableType) => {
    let currency = rootState.checkout.currencyIsoCode;

    let productId =
      cloudCableSelectionProductIds[rootState.activeProductKey] ?? 24;

    if (rootState.activeProductKey === "VG-CBL" && cableType) {
      cableType.includes("B") ? (productId = 24) : (productId = 53);
    } else if (cableType === "AG52") {
      productId = 125;
    }
    let response = await axios({
      method: "POST",
      url: ["USD", "CAD"].includes(currency)
        ? "/webstore/submit-cables"
        : "/webstore/submit-emea-cables",
      headers: { "Content-type": "application/json" },
      data: {
        type: "mmy",
        data: state.mmyData.map((row) => {
          return Object.keys(row).reduce((obj, key) => {
            if (row[key]) {
              obj[key] = row[key];
            }
            return { ...obj, productId: productId };
          }, {});
        }),
      },
    });
    if (response.status === 200) {
      let validCables = [];

      const errorCables = [];

      response.data.cableList.forEach((cable) => {
        cable.error ? errorCables.push(cable) : validCables.push(cable);
      });

      const outOfStockCables = [];
      validCables = validCables.filter((cable) => {
        if (
          cable.cable in rootState.productCatalog?.CBL?.["AG-CBL"]?.offerings ||
          cable.cable in rootState.productCatalog?.CBL?.["VG-CBL"]?.offerings
        ) {
          return cable;
        } else {
          outOfStockCables.push(cable);
          return false;
        }
      });

      commit("setSubmittedMMYData", validCables);
      return { errorCables, outOfStockCables };
    } else {
      throw "unhandledStatusCode";
    }
  },
};
